// /stacks/stocks/frontend/src/App.tsx
import React from "react";
import { BrowserRouter, Routes, Route, NavLink, Navigate } from "react-router-dom";

// Existing components used by the current dashboard:
import Ticker from "./components/Ticker";
import SymbolPicker from "./components/SymbolPicker";
import MinuteOverlayChart from "./components/MinuteOverlayChart";
import DailyChart from "./components/DailyChart";
import { getApiBaseInUse } from "./api";

// The new page you already have in the repo:
import WatchlistPage from "./WatchlistPage";

/** ---- Your current dashboard content extracted into a component ---- */
function DashboardHome() {
  const [symbol, setSymbol] = React.useState("NVDA");

  return (
    <div className="wrapper">
      <h1>Stocks Dashboard</h1>
      <p className="subtle">All times shown in New York (EST/EDT).</p>

      <div className="grid">
        <Ticker />
      </div>

      <div className="card">
        <div className="row">
          <h2 style={{ margin: 0 }}>Symbol</h2>
          <SymbolPicker value={symbol} onChange={setSymbol} />
          <small className="muted">Press letters to jump. Selection is saved &amp; reflected in the URL.</small>
        </div>
      </div>

      <div className="grid grid-2">
        <MinuteOverlayChart symbol={symbol} />
        <DailyChart symbol={symbol} days={460} />
      </div>

      <div style={{ marginTop: 18 }} className="muted">
        <small>
          API base in use: <code>{getApiBaseInUse()}</code> • Served by Nginx at <code>/app/</code>
        </small>
      </div>
    </div>
  );
}

/** ---- Small top navigation ---- */
function TopNav() {
  const linkStyle: React.CSSProperties = { padding: "8px 12px", borderRadius: 8, textDecoration: "none" };

  return (
    <div className="wrapper" style={{ marginTop: 16, marginBottom: 8 }}>
      <nav
        className="card"
        style={{ display: "flex", gap: 10, alignItems: "center", justifyContent: "space-between" }}
      >
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <strong>Stocks</strong>
          <NavLink to="/" end style={linkStyle} className={({ isActive }) => (isActive ? "active" : "")}>
            Dashboard
          </NavLink>
          <NavLink to="/watchlist" style={linkStyle} className={({ isActive }) => (isActive ? "active" : "")}>
            Watchlist
          </NavLink>
        </div>
        {/* removed debug hint that showed “/app/ SPA” */}
      </nav>
      <style>{`.active{ outline:2px solid var(--accent); }`}</style>
    </div>
  );
}

/** ---- App with Router ---- */
export default function App() {
  return (
    <BrowserRouter basename="/app">
      <TopNav />
      <Routes>
        <Route index element={<DashboardHome />} />
        <Route path="/watchlist" element={<WatchlistPage />} />
        {/* Safety: redirect anything unknown back to the dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
